module.exports = __webpack_public_path__ + "img/cover.2b135906.png";